import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* 课题组信息 */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="/yunnan-university-logo.jpg" 
                alt="云南大学" 
                className="w-8 h-8 object-contain"
              />
              <h3 className="text-lg font-bold">云南大学|张文华课题组</h3>
            </div>
            <p className="text-gray-300 mb-4 max-w-md">
              专注于钙钛矿材料与器件的前沿研究，致力于推动新能源技术的发展，
              为可持续发展贡献力量。
            </p>
            <div className="flex space-x-4">
              <a href="mailto:contact@ynuzhangwenhua.cn" className="text-gray-400 hover:text-white transition-colors">
                <span className="sr-only">邮箱</span>
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                </svg>
              </a>
              <button className="text-gray-400 hover:text-white transition-colors">
                <span className="sr-only">微信</span>
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z" clipRule="evenodd" />
                </svg>
              </button>
            </div>
          </div>

          {/* 快速链接 */}
          <div>
            <h4 className="text-sm font-semibold text-gray-300 uppercase tracking-wider mb-4">
              快速链接
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/research" className="text-gray-400 hover:text-white transition-colors">
                  研究方向
                </Link>
              </li>
              <li>
                <Link to="/members" className="text-gray-400 hover:text-white transition-colors">
                  团队成员
                </Link>
              </li>
              <li>
                <Link to="/news" className="text-gray-400 hover:text-white transition-colors">
                  新闻动态
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-white transition-colors">
                  联系我们
                </Link>
              </li>
            </ul>
          </div>

          {/* 联系信息 */}
          <div>
            <h4 className="text-sm font-semibold text-gray-300 uppercase tracking-wider mb-4">
              联系我们
            </h4>
            <ul className="space-y-2 text-gray-400">
              <li className="flex items-start space-x-2">
                <svg className="h-4 w-4 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                </svg>
                <span>云南大学呈贡校区材料与能源学院</span>
              </li>
              <li className="flex items-start space-x-2">
                <svg className="h-4 w-4 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                </svg>
                <span>contact@ynuzhangwenhua.cn</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="flex space-x-6 mt-4 md:mt-0">
              <button className="text-gray-400 hover:text-white text-sm">
                隐私政策
              </button>
              <button className="text-gray-400 hover:text-white text-sm">
                使用条款
              </button>
            </div>
          </div>
          {/* 版权信息和ICP备案号 */}
          <div className="mt-4 text-center">
            <p className="text-gray-400 text-sm">
              © 2025 云南大学张文华课题组版权所有 | 
              <a 
                href="https://beian.miit.gov.cn" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white text-sm transition-colors ml-1"
              >
                冀ICP备2025129025号-1
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 